/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipTypeLinkLangViewModel } from "../types/ScholarshipTypeLinkLangViewModel.ts";

export const scholarshipTypeLinkLangViewModelSchema = z.object({
  culture: z.string().describe("Código do idioma (cultura) do link.").nullish(),
  link: z
    .string()
    .describe(
      "URL de matrícula da ficha nova, com os parâmetros criptografados no id (para aplicar a bolsa) e o idioma na query string.",
    )
    .nullish(),
}) as unknown as ToZod<ScholarshipTypeLinkLangViewModel>;
